import { languages as interfaceLanguages } from 'src/i18n/languages.js'

// Languages a post can be marked with: the interface languages and other
// widely used ones, as plain ISO 639 codes.

const MORE = [
  'bn',
  'da',
  'el',
  'fa',
  'hi',
  'id',
  'ms',
  'pa',
  'sv',
  'sw',
  'th',
  'tr',
  'uk',
  'ur',
  'vi',
  'zh',
]

// 'ja_easy' → 'ja', 'zh-Hant' → 'zh'
export const baseLanguage = (code) =>
  code ? code.split(/[-_]/)[0].toLowerCase() : null

// the list, with the given language added when it is not in it
export const postLanguages = (locale, current) => {
  const names = new Intl.DisplayNames([locale, 'en'], { type: 'language' })
  const codes = [
    ...new Set([
      ...interfaceLanguages.map(baseLanguage),
      ...MORE,
      baseLanguage(current),
    ]),
  ].filter(Boolean)
  return codes
    .map((code) => ({
      code,
      name: names.of(code),
      // its own name, to find it by: "Deutsch" in an English interface
      native: new Intl.DisplayNames([code], { type: 'language' }).of(code),
    }))
    .sort((a, b) => a.name.localeCompare(b.name, locale))
}

// lower case, without accents: "Français" → "francais"
const plain = (text) =>
  text
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()

// the languages a search matches by name, own name or code; an exact code
// first. An empty search keeps them all.
export const filterLanguages = (languages, query) => {
  const q = plain(query.trim())
  if (!q) return languages
  const matches = languages.filter(({ code, name, native }) =>
    [code, name, native].some((text) => text && plain(text).includes(q)),
  )
  return [
    ...matches.filter(({ code }) => code === q),
    ...matches.filter(({ code }) => code !== q),
  ]
}

// the interface language as a plain code; the setting is a list, or a
// single code in older settings
export const interfaceBaseLanguage = (interfaceLanguage, fallback) =>
  baseLanguage([].concat(interfaceLanguage ?? [])[0] ?? fallback)
